import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filterArrOfObjByVal",
    pure: false,
    standalone: false
})
export class FilterArrOfObjByValPipe implements PipeTransform {
  transform(array: any[], keyname: any, keyvalue: any): unknown {
    if (!Array.isArray(array) || !keyname) return [];

    return array.filter((item: any) => item[keyname] === keyvalue);
  }
}
